import { render } from "./componentTitleEn.vue?vue&type=template&id=19a788c1&scoped=true&ts=true"
import script from "./componentTitleEn.vue?vue&type=script&lang=ts"
export * from "./componentTitleEn.vue?vue&type=script&lang=ts"

import "./componentTitleEn.vue?vue&type=style&index=0&id=19a788c1&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a788c1"]])

export default __exports__